/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DateString } from './dateString';

export interface FolderDescriptor { 
    entity_id: string;
    name: string;
    creator_account_id: string;
    created: DateString;
    modified: DateString;
    modified_by: string;
    readonly: boolean;
}